/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Staking, StakingInterface } from "../Staking";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "controller",
        type: "address",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_lbaStakeTime",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "AccessDenied",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "ContractError",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "InvalidInput",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UnStaked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ASTO_TOKEN_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LP_TOKEN_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addConsumer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "getHistory",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "time",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        internalType: "struct IStaking.Stake[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getStorageAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getTokenAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getTotalValueLocked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dao",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "astoToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "astoStorage",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "lpToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "lpStorage",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "totalStakedAsto",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalStakedLp",
        type: "uint256",
      },
    ],
    name: "init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lbaMigrated",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lbaStakeTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
    ],
    name: "migrateAuctionLP",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "addresses",
        type: "address[]",
      },
    ],
    name: "migrateHistory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeConsumer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newController",
        type: "address",
      },
    ],
    name: "setController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newDao",
        type: "address",
      },
    ],
    name: "setDao",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_time",
        type: "uint256",
      },
    ],
    name: "setLBAStakeTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "setSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "setTokenAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "stakeFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "totalStakedAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "unstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "hash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "token",
        type: "bytes",
      },
    ],
    name: "validateSignature",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040526002805461ff00191690553480156200001c57600080fd5b5060405162003927380380620039278339810160408190526200003f916200031e565b6002805460ff191690556001600160a01b0383163b620000a557604080518082018252601281527124b73b30b634b21021b7b73a3937b63632b960711b6020820152905163d647364f60e01b81526200009c91906004016200035f565b60405180910390fd5b600480546001600160a01b0319166001600160a01b0384161790556003819055620000f17f7b765e0e932d348852a6f810bfa1ab891e259123f02db8cdcde614c5702233578462000104565b620000fb62000147565b505050620003af565b6200011b8282620001a460201b62001ea21760201c565b60008281526001602090815260409091206200014291839062001f2662000245821b17901c565b505050565b6200015162000265565b6002805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258620001873390565b6040516001600160a01b03909116815260200160405180910390a1565b6000828152602081815260408083206001600160a01b038516845290915290205460ff1662000241576000828152602081815260408083206001600160a01b03851684529091529020805460ff19166001179055620002003390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45b5050565b60006200025c836001600160a01b038416620002af565b90505b92915050565b60025460ff1615620002ad5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b60448201526064016200009c565b565b6000818152600183016020526040812054620002f8575081546001818101845560008481526020808220909301849055845484825282860190935260409020919091556200025f565b5060006200025f565b80516001600160a01b03811681146200031957600080fd5b919050565b6000806000606084860312156200033457600080fd5b6200033f8462000301565b92506200034f6020850162000301565b9150604084015190509250925092565b600060208083528351808285015260005b818110156200038e5785810183015185820160400152820162000370565b506000604082860101526040601f19601f8301168501019250505092915050565b61356880620003bf6000396000f3fe608060405234801561001057600080fd5b50600436106102325760003560e01c8063688011df116101305780639e2c8a5b116100b8578063d547741f1161007c578063d547741f146104fe578063d9d3a9b414610511578063e63697c814610519578063ed1bebb31461052c578063f671f38f1461055557600080fd5b80639e2c8a5b146104bd5780639fef2704146104d0578063a217fddf146104d0578063ac18de43146104d8578063ca15c873146104eb57600080fd5b80637c9a9b6e116100ff5780637c9a9b6e146104695780638456cb591461047c5780639010d07c1461048457806391d148541461049757806392eefe9b146104aa57600080fd5b8063688011df146104035780636c19e783146104235780636cd0a918146104365780637b0472f01461045657600080fd5b806336568abe116101be57806358e9a8151161018257806358e9a8151461036e5780635c975abb146103815780635d5d6ef11461038c5780636637b882146103af57806367ccdf38146103c257600080fd5b806336568abe146103175780633f4ba83a1461032a5780633f5d9235146103325780634cf1b14014610352578063569966031461036557600080fd5b8063248a9ca311610205578063248a9ca31461029a578063287e96c1146102cb5780632d06177a146102de5780632f2ff15d146102f1578063333daf921461030457600080fd5b806301ffc9a7146102375780630e27e3df1461025f5780630fd07ea414610274578063112940f914610287575b600080fd5b61024a610245366004612bd0565b610568565b60405190151581526020015b60405180910390f35b61027261026d366004612c0f565b610593565b005b610272610282366004612c2c565b610669565b610272610295366004612c0f565b6108f8565b6102bd6102a8366004612caf565b60009081526020819052604090206001015490565b604051908152602001610256565b6102726102d9366004612cc8565b6109ba565b6102726102ec366004612c0f565b610a4a565b6102726102ff366004612cc8565b610b0c565b61024a610312366004612d3f565b610b36565b610272610325366004612cc8565b610b60565b610272610bda565b6102bd610340366004612caf565b60009081526008602052604090205490565b610272610360366004612dde565b610bfd565b6102bd60035481565b61027261037c366004612e5a565b610ec0565b60025460ff1661024a565b61024a61039a366004612c0f565b60096020526000908152604090205460ff1681565b6102726103bd366004612c0f565b611283565b6103eb6103d0366004612caf565b6000908152600560205260409020546001600160a01b031690565b6040516001600160a01b039091168152602001610256565b610416610411366004612e8f565b6112ca565b6040516102569190612ec7565b610272610431366004612c0f565b61135b565b6102bd610444366004612caf565b60086020526000908152604090205481565b610272610464366004612f16565b611396565b610272610477366004612caf565b611730565b61027261174e565b6103eb610492366004612f16565b61176e565b61024a6104a5366004612cc8565b611786565b6102726104b8366004612c0f565b6117af565b6102726104cb366004612f16565b6117f6565b6102bd600081565b6102726104e6366004612c0f565b611b6b565b6102bd6104f9366004612caf565b611c2d565b61027261050c366004612cc8565b611c44565b6102bd600181565b610272610527366004612e8f565b611c69565b6103eb61053a366004612caf565b6000908152600760205260409020546001600160a01b031690565b610272610563366004612f38565b611e1d565b60006001600160e01b03198216635a05180f60e01b148061058d575061058d82611f3b565b92915050565b604080518082019091526000805160206134f383398151915281526000805160206134d383398151915260208201526105d48160005b602002015133611786565b1580156105e957506105e78160016105c9565b155b1561063b5760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106329190600401612fde565b60405180910390fd5b6106657f9d56108290ea0bc9c5c59c3ad357dca9d1b29ed7f3ae1443bef2fa2159bdf5e883611f70565b5050565b6000805160206134f383398151915261068181611f92565b600254610100900460ff166108ee577f05b8ccbb9d4d8fb16ea74ce3c29a41f1b461fbdaff4714a0d9a8eb05499746bc80546001600160a01b03808a166001600160a01b0319928316179092557f6d5257204ebe7d88fd91ae87941cb2dd9d8062b64ae5a2bd2d28ec40b9fbf6df8054928916929091169190911790556040805180820190915260048152634153544f60e01b60208281019190915260008052600690527f54cdd369e4e8a8515e52ca72ec816c2101831ad1f18bf44102ed171459c9b4f8906107519082613099565b507f1471eb6eb2c5e789fc3de43f8ce62938c7d1836ec861730447e2ada8fd81017b80546001600160a01b038088166001600160a01b0319928316179092557fb39221ace053465ec3453ce2b36430bd138b997ecea25c1043da0c366812b82880549287169290911691909117905560408051808201909152601781527f4153544f2f5553444320556e6973776170205632204c500000000000000000006020828101919091526001600052600690527f3e5fec24aa4dc4e5aee2e025e51e1392c72a2500577559fae9665c6d52bd6a319061082d9082613099565b506108456000805160206134b3833981519152611f9c565b61085d6000805160206134b383398151915289611fdb565b6108746000805160206134d3833981519152611f9c565b61088c6000805160206134d383398151915289611fdb565b60086020527f5eff886ea0ce6ca488a3d6e336d6c0f75f46d19b42c06ce5ee98e42c96d256c783905560016000527fad67d757c34507f157cacfa2e3153e9f260a2244f30428821be7be64587ac55f8290556002805461ff0019166101001790555b5050505050505050565b604080518082019091526000805160206134f383398151915281526000805160206134d383398151915260208201526109328160006105c9565b15801561094757506109458160016105c9565b155b156109905760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106329190600401612fde565b6106657f9d56108290ea0bc9c5c59c3ad357dca9d1b29ed7f3ae1443bef2fa2159bdf5e883611fdb565b6000805160206134b38339815191526109d281611f92565b6001600160a01b0382163b610a1b57604080518082018252601d81526000805160206135138339815191526020820152905163d647364f60e01b81526106329190600401612fde565b5060009182526005602052604090912080546001600160a01b0319166001600160a01b03909216919091179055565b604080518082019091526000805160206134f383398151915281526000805160206134d38339815191526020820152610a848160006105c9565b158015610a995750610a978160016105c9565b155b15610ae25760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106329190600401612fde565b6106657f241ecf16d79d0f8dbfb92cbc07fe17840425976cf0667f022fe9877caa831b0883611fdb565b600082815260208190526040902060010154610b2781611f92565b610b318383611fdb565b505050565b6004546000906001600160a01b0316610b4f8484611ffd565b6001600160a01b0316149392505050565b6001600160a01b0381163314610bd05760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b6064820152608401610632565b6106658282611f70565b6000805160206134f3833981519152610bf281611f92565b610bfa612060565b50565b610c056120b2565b3360008181526009602052604090205460ff1615610c5c57604080518082018252601081526f105b1c9958591e481b5a59dc985d195960821b6020820152905163d647364f60e01b81526106329190600401612fde565b604080513360208083019190915281830187905282518083038401815260609092019092528051910120610cc69084848080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250610b3692505050565b610d0a576040805180820182526011815270496e76616c6964207369676e617475726560781b6020820152905163d647364f60e01b81526106329190600401612fde565b600160005260056020527f1471eb6eb2c5e789fc3de43f8ce62938c7d1836ec861730447e2ada8fd81017b54610d4b906001600160a01b03168230876120fa565b600160005260076020527fb39221ace053465ec3453ce2b36430bd138b997ecea25c1043da0c366812b8285460035460405163486b08b360e11b81526001600160a01b0384811660048301526024820188905260448201929092529116906390d6116690606401600060405180830381600087803b158015610dcc57600080fd5b505af1158015610de0573d6000803e3d6000fd5b505050506001600160a01b03811660009081526009602090815260408220805460ff191660019081179091558252600890527fad67d757c34507f157cacfa2e3153e9f260a2244f30428821be7be64587ac55f8054869290610e4390849061316f565b9091555050600160005260066020526003546040516001600160a01b038316917f9c4e10a273cf0ad27bb560a0f45dd6e1ac5fd64e50812a1537ceb6ee914eed2591610eb2917f3e5fec24aa4dc4e5aee2e025e51e1392c72a2500577559fae9665c6d52bd6a31918990613182565b60405180910390a250505050565b610ec86120b2565b7f9d56108290ea0bc9c5c59c3ad357dca9d1b29ed7f3ae1443bef2fa2159bdf5e8610ef281611f92565b6001831115610f3557604080518082018252601d81526000805160206135138339815191526020820152905163d647364f60e01b81526106329190600401612fde565b81600003610f8257604080518082018252601681527515dc9bdb99c81bdc881b5a5cdcd95908185b5bdd5b9d60521b6020820152905163d647364f60e01b81526106329190600401612fde565b6000838152600560205260408082205490516370a0823160e01b81523360048201526001600160a01b03909116906370a0823190602401602060405180830381865afa158015610fd6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ffa9190613218565b905080831115611047576040805180820182526014815273496e73756666696369656e742062616c616e636560601b6020820152905163d647364f60e01b81526106329190600401612fde565b60008481526005602052604090205461106b906001600160a01b03163330866120fa565b60008481526007602052604080822054905163ee98b9cf60e01b81526001600160a01b0388811660048301529091169063ee98b9cf90602401602060405180830381865afa1580156110c1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110e59190613218565b60008681526007602052604080822054905163cfd4766360e01b81526001600160a01b038a81166004830152602482018590529394509192169063cfd47663906044016040805180830381865afa158015611144573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111689190613280565b602001519050600061117a868361316f565b6000888152600760205260409081902054905163777aff7d60e01b81526001600160a01b038b811660048301526024820184905292935091169063777aff7d906044016020604051808303816000875af11580156111dc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112009190613218565b506000878152600860205260408120805488929061121f90849061316f565b90915550506000878152600660205260409081902090516001600160a01b038a16917f9c4e10a273cf0ad27bb560a0f45dd6e1ac5fd64e50812a1537ceb6ee914eed2591611271919042908b90613182565b60405180910390a25050505050505050565b6000805160206134f383398151915261129b81611f92565b6112b26000805160206134b3833981519152611f9c565b6106656000805160206134b383398151915283611fdb565b60008381526007602052604090819020549051638bdf580360e01b81526001600160a01b038481166004830152602482018490526060921690638bdf580390604401600060405180830381865afa158015611329573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611351919081019061329c565b90505b9392505050565b6000805160206134b383398151915261137381611f92565b50600480546001600160a01b0319166001600160a01b0392909216919091179055565b61139e6120b2565b60018211156113e157604080518082018252601d81526000805160206135138339815191526020820152905163d647364f60e01b81526106329190600401612fde565b8060000361142e57604080518082018252601681527515dc9bdb99c81bdc881b5a5cdcd95908185b5bdd5b9d60521b6020820152905163d647364f60e01b81526106329190600401612fde565b6000828152600560205260408082205490516370a0823160e01b8152336004820181905292916001600160a01b0316906370a0823190602401602060405180830381865afa158015611484573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114a89190613218565b9050808311156114f5576040805180820182526014815273496e73756666696369656e742062616c616e636560601b6020820152905163d647364f60e01b81526106329190600401612fde565b600084815260056020526040902054611519906001600160a01b03168330866120fa565b60008481526007602052604080822054905163ee98b9cf60e01b81526001600160a01b0385811660048301529091169063ee98b9cf90602401602060405180830381865afa15801561156f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115939190613218565b60008681526007602052604080822054905163cfd4766360e01b81526001600160a01b038781166004830152602482018590529394509192169063cfd47663906044016040805180830381865afa1580156115f2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116169190613280565b6020015190506000611628868361316f565b6000888152600760205260409081902054905163777aff7d60e01b81526001600160a01b0388811660048301526024820184905292935091169063777aff7d906044016020604051808303816000875af115801561168a573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116ae9190613218565b50600087815260086020526040812080548892906116cd90849061316f565b90915550506000878152600660205260409081902090516001600160a01b038716917f9c4e10a273cf0ad27bb560a0f45dd6e1ac5fd64e50812a1537ceb6ee914eed259161171f919042908b90613182565b60405180910390a250505050505050565b6000805160206134b383398151915261174881611f92565b50600355565b6000805160206134f383398151915261176681611f92565b610bfa612165565b600082815260016020526040812061135490836121a2565b6000918252602082815260408084206001600160a01b0393909316845291905290205460ff1690565b6000805160206134f38339815191526117c781611f92565b6117de6000805160206134f3833981519152611f9c565b6106656000805160206134f383398151915283611fdb565b6117fe6120b2565b6000828152600560205260409020546001600160a01b03163b61185557604080518082018252601d81526000805160206135138339815191526020820152905163d647364f60e01b81526106329190600401612fde565b806000036118a257604080518082018252601681527515dc9bdb99c81bdc881b5a5cdcd95908185b5bdd5b9d60521b6020820152905163d647364f60e01b81526106329190600401612fde565b60008281526007602052604080822054905163ee98b9cf60e01b8152336004820181905292916001600160a01b03169063ee98b9cf90602401602060405180830381865afa1580156118f8573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061191c9190613218565b90508060000361196257604080518082018252600d81526c139bc81cdd185ad95cc81e595d609a1b6020820152905163d647364f60e01b81526106329190600401612fde565b60008481526007602052604080822054905163cfd4766360e01b81526001600160a01b038581166004830152602482018590529091169063cfd47663906044016040805180830381865afa1580156119be573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119e29190613280565b60200151905080841115611a33576040805180820182526014815273496e73756666696369656e742062616c616e636560601b6020820152905163d647364f60e01b81526106329190600401612fde565b6000611a3f8583613344565b6000878152600760205260409081902054905163777aff7d60e01b81526001600160a01b0387811660048301526024820184905292935091169063777aff7d906044016020604051808303816000875af1158015611aa1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611ac59190613218565b5060008681526008602052604081208054879290611ae4908490613344565b9091555050600086815260056020526040902054611b0c906001600160a01b031685876121ae565b836001600160a01b03167fc85c348c201a72fc87bc9718569d11186b58b0a0d5993ee29bbdfe46e1371059600660008981526020019081526020016000204288604051611b5b93929190613182565b60405180910390a2505050505050565b604080518082019091526000805160206134f383398151915281526000805160206134d38339815191526020820152611ba58160006105c9565b158015611bba5750611bb88160016105c9565b155b15611c035760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106329190600401612fde565b6106657f241ecf16d79d0f8dbfb92cbc07fe17840425976cf0667f022fe9877caa831b0883611f70565b600081815260016020526040812061058d906121de565b600082815260208190526040902060010154611c5f81611f92565b610b318383611f70565b6000805160206134b3833981519152611c8181611f92565b6000848152600560205260409020546001600160a01b03163b611cd857604080518082018252601d81526000805160206135138339815191526020820152905163d647364f60e01b81526106329190600401612fde565b6001600160a01b038316611d3257604080518082018252601e81527f57726f6e67206f72206d69737365642077616c6c6574206164647265737300006020820152905163d647364f60e01b81526106329190600401612fde565b600084815260056020526040908190205490516370a0823160e01b815230600482015283916001600160a01b0316906370a0823190602401602060405180830381865afa158015611d87573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611dab9190613218565b1015611df4576040805180820182526014815273496e73756666696369656e742062616c616e636560601b6020820152905163d647364f60e01b81526106329190600401612fde565b600084815260056020526040902054611e17906001600160a01b031684846121ae565b50505050565b6000805160206134b3833981519152611e3581611f92565b60008481526007602052604090819020549051633ca3c46f60e21b81526001600160a01b039091169063f28f11bc90611e749086908690600401613357565b600060405180830381600087803b158015611e8e57600080fd5b505af11580156108ee573d6000803e3d6000fd5b611eac8282611786565b610665576000828152602081815260408083206001600160a01b03851684529091529020805460ff19166001179055611ee23390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000611354836001600160a01b0384166121e8565b60006001600160e01b03198216637965db0b60e01b148061058d57506301ffc9a760e01b6001600160e01b031983161461058d565b611f7a8282612237565b6000828152600160205260409020610b31908261229c565b610bfa81336122b1565b6000611fa782611c2d565b9050805b8015610b3157611fc983611fc481610492600186613344565b611f70565b80611fd3816133a5565b915050611fab565b611fe58282611ea2565b6000828152600160205260409020610b319082611f26565b60006113548261205a856040517f19457468657265756d205369676e6564204d6573736167653a0a3332000000006020820152603c8101829052600090605c01604051602081830303815290604052805190602001209050919050565b90612315565b612068612339565b6002805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b60025460ff16156120f85760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b6044820152606401610632565b565b6040516001600160a01b0380851660248301528316604482015260648101829052611e179085906323b872dd60e01b906084015b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b031990931692909217909152612382565b61216d6120b2565b6002805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586120953390565b60006113548383612454565b6040516001600160a01b038316602482015260448101829052610b3190849063a9059cbb60e01b9060640161212e565b600061058d825490565b600081815260018301602052604081205461222f5750815460018181018455600084815260208082209093018490558454848252828601909352604090209190915561058d565b50600061058d565b6122418282611786565b15610665576000828152602081815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b6000611354836001600160a01b03841661247e565b6122bb8282611786565b610665576122d3816001600160a01b03166014612571565b6122de836020612571565b6040516020016122ef9291906133bc565b60408051601f198184030181529082905262461bcd60e51b825261063291600401612fde565b6000806000612324858561270d565b915091506123318161277b565b509392505050565b60025460ff166120f85760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b6044820152606401610632565b60006123d7826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166129319092919063ffffffff16565b805190915015610b3157808060200190518101906123f59190613431565b610b315760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b6064820152608401610632565b600082600001828154811061246b5761246b612fa4565b9060005260206000200154905092915050565b600081815260018301602052604081205480156125675760006124a2600183613344565b85549091506000906124b690600190613344565b905081811461251b5760008660000182815481106124d6576124d6612fa4565b90600052602060002001549050808760000184815481106124f9576124f9612fa4565b6000918252602080832090910192909255918252600188019052604090208390555b855486908061252c5761252c613453565b60019003818190600052602060002001600090559055856001016000868152602001908152602001600020600090556001935050505061058d565b600091505061058d565b60606000612580836002613469565b61258b90600261316f565b67ffffffffffffffff8111156125a3576125a3612cf8565b6040519080825280601f01601f1916602001820160405280156125cd576020820181803683370190505b509050600360fc1b816000815181106125e8576125e8612fa4565b60200101906001600160f81b031916908160001a905350600f60fb1b8160018151811061261757612617612fa4565b60200101906001600160f81b031916908160001a905350600061263b846002613469565b61264690600161316f565b90505b60018111156126be576f181899199a1a9b1b9c1cb0b131b232b360811b85600f166010811061267a5761267a612fa4565b1a60f81b82828151811061269057612690612fa4565b60200101906001600160f81b031916908160001a90535060049490941c936126b7816133a5565b9050612649565b5083156113545760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e746044820152606401610632565b60008082516041036127435760208301516040840151606085015160001a61273787828585612940565b94509450505050612774565b825160400361276c5760208301516040840151612761868383612a2d565b935093505050612774565b506000905060025b9250929050565b600081600481111561278f5761278f613480565b036127975750565b60018160048111156127ab576127ab613480565b036127f85760405162461bcd60e51b815260206004820152601860248201527f45434453413a20696e76616c6964207369676e617475726500000000000000006044820152606401610632565b600281600481111561280c5761280c613480565b036128595760405162461bcd60e51b815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e677468006044820152606401610632565b600381600481111561286d5761286d613480565b036128c55760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c604482015261756560f01b6064820152608401610632565b60048160048111156128d9576128d9613480565b03610bfa5760405162461bcd60e51b815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202776272076616c604482015261756560f01b6064820152608401610632565b60606113518484600085612a66565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a08311156129775750600090506003612a24565b8460ff16601b1415801561298f57508460ff16601c14155b156129a05750600090506004612a24565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa1580156129f4573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b038116612a1d57600060019250925050612a24565b9150600090505b94509492505050565b6000806001600160ff1b03831681612a4a60ff86901c601b61316f565b9050612a5887828885612940565b935093505050935093915050565b606082471015612ac75760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6044820152651c8818d85b1b60d21b6064820152608401610632565b6001600160a01b0385163b612b1e5760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606401610632565b600080866001600160a01b03168587604051612b3a9190613496565b60006040518083038185875af1925050503d8060008114612b77576040519150601f19603f3d011682016040523d82523d6000602084013e612b7c565b606091505b5091509150612b8c828286612b97565b979650505050505050565b60608315612ba6575081611354565b825115612bb65782518084602001fd5b8160405162461bcd60e51b81526004016106329190612fde565b600060208284031215612be257600080fd5b81356001600160e01b03198116811461135457600080fd5b6001600160a01b0381168114610bfa57600080fd5b600060208284031215612c2157600080fd5b813561135481612bfa565b600080600080600080600060e0888a031215612c4757600080fd5b8735612c5281612bfa565b96506020880135612c6281612bfa565b95506040880135612c7281612bfa565b94506060880135612c8281612bfa565b93506080880135612c9281612bfa565b9699959850939692959460a0840135945060c09093013592915050565b600060208284031215612cc157600080fd5b5035919050565b60008060408385031215612cdb57600080fd5b823591506020830135612ced81612bfa565b809150509250929050565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715612d3757612d37612cf8565b604052919050565b60008060408385031215612d5257600080fd5b8235915060208084013567ffffffffffffffff80821115612d7257600080fd5b818601915086601f830112612d8657600080fd5b813581811115612d9857612d98612cf8565b612daa601f8201601f19168501612d0e565b91508082528784828501011115612dc057600080fd5b80848401858401376000848284010152508093505050509250929050565b600080600060408486031215612df357600080fd5b83359250602084013567ffffffffffffffff80821115612e1257600080fd5b818601915086601f830112612e2657600080fd5b813581811115612e3557600080fd5b876020828501011115612e4757600080fd5b6020830194508093505050509250925092565b600080600060608486031215612e6f57600080fd5b8335612e7a81612bfa565b95602085013595506040909401359392505050565b600080600060608486031215612ea457600080fd5b833592506020840135612eb681612bfa565b929592945050506040919091013590565b602080825282518282018190526000919060409081850190868401855b82811015612f0957815180518552860151868501529284019290850190600101612ee4565b5091979650505050505050565b60008060408385031215612f2957600080fd5b50508035926020909101359150565b600080600060408486031215612f4d57600080fd5b83359250602084013567ffffffffffffffff80821115612f6c57600080fd5b818601915086601f830112612f8057600080fd5b813581811115612f8f57600080fd5b8760208260051b8501011115612e4757600080fd5b634e487b7160e01b600052603260045260246000fd5b60005b83811015612fd5578181015183820152602001612fbd565b50506000910152565b6020815260008251806020840152612ffd816040850160208701612fba565b601f01601f19169190910160400192915050565b600181811c9082168061302557607f821691505b60208210810361304557634e487b7160e01b600052602260045260246000fd5b50919050565b601f821115610b3157600081815260208120601f850160051c810160208610156130725750805b601f850160051c820191505b818110156130915782815560010161307e565b505050505050565b815167ffffffffffffffff8111156130b3576130b3612cf8565b6130c7816130c18454613011565b8461304b565b602080601f8311600181146130fc57600084156130e45750858301515b600019600386901b1c1916600185901b178555613091565b600085815260208120601f198616915b8281101561312b5788860151825594840194600190910190840161310c565b50858210156131495787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b634e487b7160e01b600052601160045260246000fd5b8082018082111561058d5761058d613159565b60608152600080855461319481613011565b80606086015260806001808416600081146131b657600181146131d057613201565b60ff1985168884015283151560051b880183019550613201565b8a60005260208060002060005b868110156131f85781548b82018701529084019082016131dd565b8a018501975050505b505050505060208301949094525060400152919050565b60006020828403121561322a57600080fd5b5051919050565b60006040828403121561324357600080fd5b6040516040810181811067ffffffffffffffff8211171561326657613266612cf8565b604052825181526020928301519281019290925250919050565b60006040828403121561329257600080fd5b6113548383613231565b600060208083850312156132af57600080fd5b825167ffffffffffffffff808211156132c757600080fd5b818501915085601f8301126132db57600080fd5b8151818111156132ed576132ed612cf8565b6132fb848260051b01612d0e565b818152848101925060069190911b83018401908782111561331b57600080fd5b928401925b81841015612b8c576133328885613231565b83528483019250604084019350613320565b8181038181111561058d5761058d613159565b60208082528181018390526000908460408401835b8681101561339a57823561337f81612bfa565b6001600160a01b03168252918301919083019060010161336c565b509695505050505050565b6000816133b4576133b4613159565b506000190190565b7f416363657373436f6e74726f6c3a206163636f756e74200000000000000000008152600083516133f4816017850160208801612fba565b7001034b99036b4b9b9b4b733903937b6329607d1b6017918401918201528351613425816028840160208801612fba565b01602801949350505050565b60006020828403121561344357600080fd5b8151801515811461135457600080fd5b634e487b7160e01b600052603160045260246000fd5b808202811582820484141761058d5761058d613159565b634e487b7160e01b600052602160045260246000fd5b600082516134a8818460208701612fba565b919091019291505056fe3b5d4cc60d3ec3516ee8ae083bd60934f6eb2a6c54b1229985c41bfb092b2603a5a0b70b385ff7611cd3840916bd08b10829e5bf9e6637cf79dd9a427fc0e2ab7b765e0e932d348852a6f810bfa1ab891e259123f02db8cdcde614c570223357546f6b656e206e6f7420616c6c6f77656420666f72207374616b696e67000000a26469706673582212208074f134e8cb532cad0603f88033b86cf663454faec3fc113898d7fc3b3cb0c164736f6c63430008110033";

export class Staking__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    controller: string,
    signer: string,
    _lbaStakeTime: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Staking> {
    return super.deploy(
      controller,
      signer,
      _lbaStakeTime,
      overrides || {}
    ) as Promise<Staking>;
  }
  getDeployTransaction(
    controller: string,
    signer: string,
    _lbaStakeTime: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      controller,
      signer,
      _lbaStakeTime,
      overrides || {}
    );
  }
  attach(address: string): Staking {
    return super.attach(address) as Staking;
  }
  connect(signer: Signer): Staking__factory {
    return super.connect(signer) as Staking__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new utils.Interface(_abi) as StakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Staking {
    return new Contract(address, _abi, signerOrProvider) as Staking;
  }
}
